import { thumbHashToApproximateAspectRatio, thumbHashToDataURL } from "thumbhash";

function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

// Decodes a base64-encoded ThumbHash (as embedded literally in a generated *Thumbhashes type
// declaration — see generateImageThumbhashes.ts) into a blurred placeholder data URL, for use as a
// loading background behind an <img>.
export function thumbhashToDataUrl(thumbhash: string): string {
  return thumbHashToDataURL(base64ToBytes(thumbhash));
}

// An <img> with no explicit size and no loaded src has no intrinsic box — a background-image
// placeholder painted onto it renders at 0×0 and is never actually visible. A ThumbHash encodes
// the real image's approximate aspect ratio, so a caller can reserve a real box (e.g. CSS
// `aspect-ratio`) for the placeholder to show up in before the real image has loaded.
export function thumbhashAspectRatio(thumbhash: string): number {
  return thumbHashToApproximateAspectRatio(base64ToBytes(thumbhash));
}
